import {Record, List} from 'immutable';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

const Area = Record({
    areaId: '',
    title: undefined,
    behaviors: undefined,
    institutionIds: List(),
});

function fromAPI(data) {
    const {title, institutionGroupingId, institutionIds, behaviors} = data;

    return new Area({
        areaId: institutionGroupingId,
        title,
        behaviors: new BehaviorsCollection(behaviors),
        institutionIds: List(institutionIds),
    });
}

export default {
    record: Area,
    default: new Area(),
    fromAPI,
};
